<template>
  <div>
    <status-toggle-dialog
      :is-dialog-open="dialogDelete"
      :is-loading="loading"
      :title="titulo"
      :confirmation-message="`Tem certeza que deseja ${acao} este item?`"
      :confirm="confirmarInativacao"
      @update:isDialogOpen="v => dialogDelete = v"
    />

    <v-data-table
      colspan="100%"
      no-data-text="Sem dados"
      :headers="headers"
      :items="items"
      :acesso-disable="acessoDisable"
      :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
    >
      <template #item.nome="{ item }">
        <router-link
          :to="{ name: 'fila', params: { id: item.id }}"
          class="text--primary text-truncate cursor-pointer text-decoration-none"
        >
          <v-list-item class="ml-n4">
            <div class="d-flex align-center">
              <v-avatar
                :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
                size="32"
              >
                <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
                  {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
                </span>
              </v-avatar>

              <div class="d-flex flex-column ms-3">
                {{ item.nome }}
              </div>
            </div>
          </v-list-item>
        </router-link>
      </template>

      <template #item.statusNome="{ item }">
        <v-chip
          v-if="item.statusNome === 'Ativa'"
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="'success--text'"
          :color="'success'"
        >
          {{ item.statusNome }}
        </v-chip>

        <v-chip
          v-else-if="item.statusNome === 'Inativa'"
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="'error--text'"
          :color="'error'"
        >
          {{ item.statusNome }}
        </v-chip>

        <v-chip
          v-else
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="'primary--text'"
          :color="'primary'"
        >
          {{ item.statusNome }}
        </v-chip>
      </template>

      <template #item.actions="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
            >
              <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
            </v-btn>
          </template>

          <v-list v-if="acessoDisable">
            <v-list-item v-if="item.statusNome === 'Ativa'">
              <v-list-item-title
                role="button"
                @click="inativarItem(item)"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ icons.mdiCloseThick }}
                </v-icon>
                <span>Inativar</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="item.statusNome === 'Inativa'">
              <v-list-item-title
                role="button"
                @click="ativarItem(item)"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ icons.mdiCheckBold }}
                </v-icon>
                <span>Ativar</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="item.statusNome === 'Pendente'">
              <v-list-item-title
                role="button"
                @click="ativarItem(item)"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ icons.mdiCheckBold }}
                </v-icon>
                <span>Ativar</span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="item.statusNome === 'Pendente'">
              <v-list-item-title
                role="button"
                @click="inativarItem(item)"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ icons.mdiCloseThick }}
                </v-icon>
                <span>Inativar</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mdiDotsVertical, mdiCheckBold, mdiCloseThick } from '@mdi/js'
import StatusToggleDialog from '@/components/dialog/StatusToggleDialog.vue'
import FilaService from '@/services/modules/FilaService'

export default {
  components: {
    StatusToggleDialog,
  },

  props: {
    items: {
      type: Array,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => {},
    },
    acessoDisable: {
      type: Boolean,
      default: () => true,
    },
  },

  data: () => ({
    dialogDelete: false,
    dialogInativar: false,
    loading: false,
    icons: {
      mdiDotsVertical,
      mdiCheckBold,
      mdiCloseThick,
    },
    idFila: 0,
    request: {
      ativar: true,
    },
    notificaoMsg: '',
    titulo: '',
    acao: '',
  }),

  methods: {
    confirmarInativacao() {
      this.loading = true

      FilaService
        .ativarOuInativar(this.idFila, this.request)
        .then(() => {
          this.closeDelete()
          this.$emit('confirmar-inativacao')
          this.loading = false
        })
        .catch(() => {
          this.closeDelete()
          this.loading = false
        })
    },

    atualizar() {
      this.dialogDelete = false
      this.dialogInativar = true
    },

    InativarMsg() {
      this.dialogDelete = false
    },

    inativarItem(item) {
      this.idFila = item.id
      this.request.ativar = false
      this.titulo = 'Inativação'
      this.acao = 'inativar'
      this.notificaoMsg = 'Fila inativada com sucesso'
      this.dialogDelete = true
    },

    ativarItem(item) {
      this.idFila = item.id
      this.request.ativar = true
      this.titulo = 'Ativação'
      this.acao = 'ativar'
      this.notificaoMsg = 'Fila ativada com sucesso'
      this.dialogDelete = true
    },

    closeDelete() {
      this.dialogDelete = false
    },
  },
}
</script>
